import { Grid } from '@mui/material'
import Loading from 'components/Loading/Loading'
import { ITableProps } from './ITableProps'
import { DataTableContextProvider } from './DataTableContext'
import DataTableContainer from './DataTableContainer'

export default function DataTable<T>(props: ITableProps<T>) {
    const { loading = false } = props

    if (loading)
        return (
            <Grid className="box">
                <Loading />
            </Grid>
        )

    return (
        <DataTableContextProvider props={props}>
            <DataTableContainer />
        </DataTableContextProvider>
    )
}
